import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalTransition, useModal } from 'react-simple-hook-modal';

import RequestSendSuccess from './RequestSendSuccess';
import './index.scss';

import { togglePopup, popupByName } from '../../../../store/ui';

export const RequestSendSuccessModal = () => {
    const dispatch = useDispatch();
    const { opened: isOpenModal } = useSelector(popupByName('location_request_success'));
    const { isModalOpen, openModal, closeModal } = useModal();

    useEffect(() => {
        if (isOpenModal) {
            openModal();
        }
    }, [isOpenModal, openModal]);

    const handleClose = () => {
        closeModal();
        dispatch(togglePopup({ name: 'location_request_success', status: false }));
    };

    return (
        <Modal
            id="location__request-success-modal"
            isOpen={isModalOpen}
            transition={ModalTransition.NONE}
            onBackdropClick={handleClose}
        >
            <RequestSendSuccess close={handleClose} />
        </Modal>
    );
};
